import {ArticleReferences} from './ArticleReferences';
export default ArticleReferences;
